<div class="comparison-container" [class.standard-default]="isStandardDefault">
  <mat-accordion class="comparison-accordion">
    <mat-expansion-panel #expansionPanel (opened)="onPanelOpened()">
      <mat-expansion-panel-header>
        <mat-panel-title>
          {{ 'billing.seeAllFeaturesAndComparePlans' | translate }}
        </mat-panel-title>
      </mat-expansion-panel-header>
    </mat-expansion-panel>
  </mat-accordion>
  <div
    class="comparison-container-inner"
    *ngIf="expansionPanel.expanded">
      <h4 class="typography-h4" #comparisonHeader>{{ 'billing.planComparison' | translate }}</h4>
      <!-- Plan Headers Table -->
      <div class="table-container" [class.sticky-active]="isHeaderSticky">
        <!-- Sticky Header (shown when scrolling) -->
        <div class="sticky-header-container" [class.active]="isHeaderSticky">
          <table class="plan-headers-table sticky-table">
            <thead class="plan-headers-table-header sticky-header">
              <tr>
                <th class="feature-header">
                  <app-payment-recurrence-tabs
                    [payRecurrence]="payRecurrence"
                    [hideCalculator]="true"
                    (recurrenceChange)="handleRecurrenceButtonClick($event)"
                  ></app-payment-recurrence-tabs>
                </th>
                <th class="plan-header" [class.recommended]="isRecommendedPlan(plan)" *ngFor="let plan of plans">
                  <div class="price-section-and-btn" [class.multiple-users]="userCount && userCount > 1">
                    <app-subscription-status-badge
                    *ngIf="isCurrentPlan(plan)"
                    [subscription]="currentPlan.subscription">
                  </app-subscription-status-badge>
                    <app-subscription-status-badge
                      *ngIf="isTrialOfferPlan(plan)"
                      [subscription]="trialOfferBadge"
                      [preferTrialDaysLeft]="true"
                      [trialLabelOnly]="true">
                    </app-subscription-status-badge>
                    <div class="plan-name-and-price">
                      <div class="plan-name">
                        <span class="plan-title">{{ plan.productId | titlecase }}</span>
                        <span class="per-user-under-name" *ngIf="userCount && userCount > 1">
                          per {{ userCount }} users / mo
                        </span>
                      </div>
                      <app-price-section
                        [plan]="plan"
                        [payRecurrence]="payRecurrence"
                        [hideRecurrenceMessage]="true"
                        [priceComparison]="true"
                        [userCount]="userCount"
                        [simpleRecurrenceLabel]="isStandardDefault"
                        ></app-price-section>
                    </div>
                    <app-choose-plan-buttons
                        [useChoosePlan]="!currentPlan.paymentModel?.cardLast4"
                        [currentPlan]="currentPlan"
                        [isV2]="true"
                        [plan]="plan"
                        [isCurrentPlan]="isCurrentPlan(plan)"
                        [payRecurrence]="payRecurrence"
                        [nextPaymentDateFormatted]="getNextPaymentDateFormatted()"
                        [determinePlanState]="getDeterminePlanState(plan)"
                        [getTrackingData]="getTrackingData"
                        (planCardBtnClick)="handlePlanCardBtnClick(plan, true)"
                      ></app-choose-plan-buttons>
                    </div>
                </th>
              </tr>
            </thead>
          </table>
        </div>

        <table class="plan-headers-table" #planHeadersTable>
          <thead class="plan-headers-table-header">
            <tr>
              <th class="feature-header">
                <app-payment-recurrence-tabs
                  [payRecurrence]="payRecurrence"
                  [hideCalculator]="true"
                  (recurrenceChange)="handleRecurrenceButtonClick($event)"
                ></app-payment-recurrence-tabs>
              </th>
              <th class="plan-header" [class.recommended]="isRecommendedPlan(plan)" *ngFor="let plan of plans">
                <div class="price-section-and-btn" [class.multiple-users]="userCount && userCount > 1">
                  <app-subscription-status-badge
                  *ngIf="isCurrentPlan(plan)"
                  [subscription]="currentPlan.subscription">
                </app-subscription-status-badge>
                  <app-subscription-status-badge
                    *ngIf="isTrialOfferPlan(plan)"
                    [subscription]="trialOfferBadge"
                    [preferTrialDaysLeft]="true"
                    [trialLabelOnly]="true">
                  </app-subscription-status-badge>
                  <div class="plan-name-and-price">
                    <div class="plan-name">
                      <span class="plan-title">{{ plan.productId | titlecase }}</span>
                      <span class="per-user-under-name" *ngIf="userCount && userCount > 1">
                        per {{ userCount }} users / mo
                      </span>
                    </div>
                    <app-price-section
                      [plan]="plan"
                      [payRecurrence]="payRecurrence"
                      [hideRecurrenceMessage]="true"
                      [priceComparison]="true"
                      [userCount]="userCount"
                      ></app-price-section>
                  </div>
                  <app-choose-plan-buttons
                      [useChoosePlan]="!currentPlan.paymentModel?.cardLast4"
                      [currentPlan]="currentPlan"
                      [isV2]="true"
                      [plan]="plan"
                      [isCurrentPlan]="isCurrentPlan(plan)"
                      [payRecurrence]="payRecurrence"
                      [nextPaymentDateFormatted]="getNextPaymentDateFormatted()"
                      [determinePlanState]="getDeterminePlanState(plan)"
                      [getTrackingData]="getTrackingData"
                      (planCardBtnClick)="handlePlanCardBtnClick(plan, true)"
                    ></app-choose-plan-buttons>
                  </div>
              </th>
            </tr>
          </thead>

        <tbody>
          <tr *ngIf="plans?.length">
            <td [attr.colspan]="plans.length + 1">
              <mat-accordion multi="true" class="category-accordion" togglePosition="before">
                <mat-expansion-panel
                  *ngFor="let category of plans[0].featuresLong; let categoryIndex = index"
                  [expanded]="categoryIndex === 0"
                  class="category-section no-background-when-collapsed custom-indicator"
                  [attr.data-category]="category.group">

                  <mat-expansion-panel-header>
                    <mat-panel-title>
                      {{ category.group }}
                    </mat-panel-title>
                  </mat-expansion-panel-header>

                  <table class="features-table" *ngIf="category.items">
                    <thead><th colspan="4"></th></thead>
                    <tbody>
                      <tr *ngFor="let item of category.items || []" class="feature-row">
                        <td class="feature-name">{{ item.name }}</td>
                        <td class="plan-feature" *ngFor="let plan of plans">
                          <ng-container [ngSwitch]="getFeatureValue(plan, item)">
                            <mat-icon *ngSwitchCase="'Icon'" svgIcon="check-icon"></mat-icon>
                            <span *ngSwitchCase="'N/A'" class="close-icon">-</span>
                            <span *ngSwitchDefault>{{ getFeatureValue(plan, item) }}</span>
                          </ng-container>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </mat-expansion-panel>
              </mat-accordion>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>
